export default "__VITE_ASSET__ZtMqOBm$__"